<template>
  <footer class="footer container">
    <div class="r-grid-2-1-container w-100 r-container gap-4">
      <div class="vstack w-50">
        <div class="logo-link">
          <img src="@/assets/logo/pawinhand_logo_type2.png" />
        </div>
        <div class="hstack r-mt-2 gap-2">
          <a href="http://instagram.com/pawinhand_official" target="_blank" class="sns-icon-size"><img src="@/assets/icon/sns_insta_icon.png" /></a>
          <a href="http://blog.naver.com/pawinhand" target="_blank" class="sns-icon-size"><img src="@/assets/icon/sns_naver_icon.png" /></a>
          <a href="http://pf.kakao.com/_vxaxbUxl" target="_blank" class="sns-icon-size"><img src="@/assets/icon/sns_kakao_icon.png" /></a>
          <a href="https://www.youtube.com/@pawinhand_official" target="_blank" class="sns-icon-size"><img src="@/assets/icon/sns_youtube_icon.png" /></a>
        </div>
        <div class="hstack mt-3 gap-2">
          <a href="https://play.google.com/store/apps/details?id=lost.animal.main" target="_blank" class="store-icon-size"><img src="@/assets/icon/play_store_icon.png" /></a>
          <a href="https://apps.apple.com/kr/app/%ED%8F%AC%EC%9D%B8%ED%95%B8%EB%93%9C-%EC%9C%A0%EA%B8%B0%EB%8F%99%EB%AC%BC-%EC%9E%85%EC%96%91-%EC%8B%A4%EC%A2%85%EB%8F%99%EB%AC%BC-%EC%B0%BE%EA%B8%B0/id1019549518" target="_blank" class="store-icon-size"><img src="@/assets/icon/app_store_icon.png" /></a>
        </div>
      </div>
      <div class="r-grid-3-1-container text-left site-map-container gap-3">
        <div class="vstack gap-2">
          <p class="item-title mb-1">회사</p>

          <RouterLink to="/intro">소개</RouterLink>
          <RouterLink to="/notice">공지사항</RouterLink>
          <RouterLink to="/sponsorship">후원</RouterLink>
        </div>
        <div class="vstack gap-2">
          <p class="item-title mb-1">서비스</p>

          <RouterLink to="/">홈</RouterLink>
          <RouterLink to="/shelter">보호소</RouterLink>
          <RouterLink to="/lost">실종/제보</RouterLink>
          <RouterLink to="/story">스토리</RouterLink>
          <RouterLink to="/service/statistics">유기동물 통계</RouterLink>
          <RouterLink to="/benefit">혜택</RouterLink>

        </div>
        <div class="vstack gap-2">
          <p class="item-title mb-1">문의</p>

          <RouterLink to="/question">자주하는 질문</RouterLink>
          <a href="http://pf.kakao.com/_vxaxbUxl" target="_blank">보호소 관리 시스템 도입 문의</a>
          <a href="http://pf.kakao.com/_vxaxbUxl" target="_blank">협업 문의</a>
          <a href="http://pf.kakao.com/_vxaxbUxl" target="_blank">후원 문의</a>
        </div>
        <div class="vstack gap-2">
          <p class="item-title mb-1">협력</p>

          <RouterLink to="/partner">협력 지자체</RouterLink>
          <RouterLink to="/campaign">입양 캠페인</RouterLink>
          <RouterLink to="/donation">포인기부</RouterLink>
          
        </div>
      </div>
    </div>
    <div class="w-100 vstack company-info r-container gap-1">
      
      <div class="hstack" @click="companyInfoOpen = !companyInfoOpen" style="cursor: pointer;">
        <p class="item-title">주식회사 포인핸드</p>
        <i class="ml-3 bi" :class="{'bi-chevron-up': companyInfoOpen, 'bi-chevron-down': !companyInfoOpen}" ></i>
      </div>
      <div class="vstack gap-1" v-if="companyInfoOpen">
        <p><strong>대표자</strong> 이환희 | <strong>사업자번호</strong> 322-87-00895</p>
        <p><strong>주소</strong> 서울특별시 마포구 대흥로 67</p>
        <p>유기동물 공고 제공/데이터 출처 <strong>농림축산식품부</strong></p>

        <p class="mt-2"><i class="bi bi-telephone-fill"></i> 02-6956-6242</p>
        <p><i class="bi bi-envelope-fill"></i> pawinhand@naver.com</p>

      </div>

      <p class="w-100 text-center mt-3">©Pawinhand all right reserved.</p>

    </div>

  </footer>
</template>
<script>
export default {
  name: "SiteFooter",
  data() {
    return {
      companyInfoOpen: false
    }
  }
}

</script>

<style scoped>
  @import "@/css/common.css";
  @import "@/css/style.css";

  .footer { 
    padding-top:12rem;
    padding-bottom : 12rem;
    @media (max-width: 1024px) {
      padding-top:7rem;
      padding-bottom : 7rem;
    }
  }

  strong{
    font-weight: 500;
  }

  .sns-icon-size{
    width: 28px; height: 28px;
  }

  .store-icon-size{
    width: 32px; height: 32px;
    border: 1px solid #ededed;
    border-radius: 50px;
    box-shadow: 0 0 1.5px 1.5px #ededed;

  }

  .site-map-container p, a{
    color : #000;
    font-size: 14px;
    text-decoration: none;

    @media (max-width: 1024px) {
      font-size: 12px;
    }
  }

  .item-title{
    font-size : 16px !important;
    font-weight: 600;
    @media (max-width: 1024px) {
      font-size: 14px !important;
    }
  }

  .company-info{
    border-top : 1px solid #ccc;
    margin-top : 5rem;
    padding-top : 2rem;
    @media (max-width: 1024px) {
      padding-top : 1rem;
      margin-top : 3rem;
    }
  }
  .company-info p{
    color : #000;
    font-size: 14px;

    @media (max-width: 1024px) {
      font-size: 12px;
    }
  }
</style>